import { useState, useCallback } from 'react';
import { TICKET_PURCHASE_STRINGS } from '../strings';
import * as paymentApi from '../../../services/payment/paymentService';

export default function useTicketPurchase({ serviceName, showToast }) {
  const [ticketCount, setTicketCount] = useState(0);
  const [ticketProduct, setTicketProduct] = useState(null);
  const [ticketProducts, setTicketProducts] = useState([]);


  const _loadProducts = useCallback(async () => {
    const data = await paymentApi.getBuyableTickets(serviceName);
    if (data.status === 'OK' && data.list?.length) {
      setTicketProducts(data.list);
      setTicketProduct(data.list[0]);
      return data.list;
    }
    return [];
  }, [serviceName]);


  const checkTicket = useCallback(async () => {
    const data = await paymentApi.checkTicket(serviceName);
    if (data.status === 'OK' && data.usable?.remain_count > 0) {
      setTicketCount(data.usable.remain_count);
      return true;
    }
    setTicketCount(0);
    try { await _loadProducts(); } catch {}
    return false;
  }, [serviceName, _loadProducts]);


  const loadBuyable = useCallback(async () => {
    try { await _loadProducts(); } catch {}
  }, [_loadProducts]);


  const createOrder = useCallback(async (product) => {
    let ticket = product || ticketProduct;
    if (!ticket) {
      const list = await _loadProducts();
      if (!list.length) {
        showToast(TICKET_PURCHASE_STRINGS.ERROR_NO_BUYABLE);
        return null;
      }
      ticket = list[0];
    }

    const orderData = await paymentApi.createOrder(ticket.product_key, 1);
    if (orderData.status !== 'success') {
      showToast(TICKET_PURCHASE_STRINGS.ERROR_PURCHASE_FAIL);
      return null;
    }

    return orderData;
  }, [ticketProduct, _loadProducts, showToast]);

  return { ticketCount, ticketProduct, ticketProducts, checkTicket, loadBuyable, createOrder };
}
